import Check from './Check.vue';

export * from './types';
export default Check;



// WEBPACK FOOTER //
// ./src/pages/profile/blocks/form/components/check/index.ts